<section class="clean-brand-slider">
  <div class="container">
    <h2 class="clean-brand-title">Our Trusted Brands</h2>
    <div class="clean-brand-track">
      <div class="clean-brand-logos"> 
         <!-- <img src="assets\img\brand-1.jpg" alt="Brand 1" />  -->
        <img src="/assets/img/brand/brand-7.png" alt="Brand 1" /> 
        <img src="/assets/img/brand/brand-8.png" alt="Brand 2" /> 
        <img src="/assets/img/brand/brand-9.png" alt="Brand 3" />
        <img src="/assets/img/brand/brand-10.png" alt="Brand 4" />
        <img src="/assets/img/brand/brand-11.png" alt="Brand 5" />
        <img src="/assets/img/brand/brand-12.jpg" alt="Brand 6" />
        <!-- Repeat for smooth scroll -->
        <img src="/assets/img/brand/brand-13.png" alt="Brand 7" />
        <img src="/assets/img/brand/brand-14.png" alt="Brand 8" />
         <img src="/assets/img/brand/brand-15.jpg" alt="Brand 9" />
         <img src="/assets/img/brand/brand-16.png" alt="Brand 10" />
        <img src="/assets/img/brand/brand-17.png" alt="Brand 11" />
        <img src="/assets/img/brand/brand-18.png" alt="Brand 12" />
        <img src="/assets/img/brand/brand-19.png" alt="Brand 13" />
        <img src="/assets/img/brand/brand-20.png" alt="Brand 14" />
        <img src="/assets/img/brand/brand-21.png" alt="Brand 15" />
        <img src="/assets/img/brand/brand-22.png" alt="Brand 16" />
         <img src="/assets/img/brand/brand-23.png" alt="Brand 17" /> 
        <img src="/assets/img/brand/brand-24.jpg" alt="Brand 18" /> 
        <img src="/assets/img/brand/brand-25.png" alt="Brand 19" />
        <img src="/assets/img/brand/brand-26.png" alt="Brand 20" />
        <img src="/assets/img/brand/brand-27.jpg" alt="Brand 21" />
        <img src="/assets/img/brand/brand-28.jpg" alt="Brand 22" />
      </div>
    </div>
  </div>
</section>
<section class="subscribe-area" *ngFor="let SubscribeContent of subscribeArea;" [ngStyle]="{'background-image': 'url(' + SubscribeContent.bgImage + ')'}">
    <div class="container">
        <div class="subscribe-content">
            <div class="section-title">
                <span class="sub-title">{{SubscribeContent.subTitle}}</span>
                <h2>{{SubscribeContent.title}}</h2>
                <p class="description">Stay updated with our latest news and offers.</p>
            </div>

            <form class="newsletter-form" (ngSubmit)="onSubmit()" #subscribeForm="ngForm">
                <div class="input-group">
                    <span class="icon"><i class='bx bx-envelope-open'></i></span>
                    <input 
                        type="email" 
                        class="input-newsletter" 
                        placeholder="Enter your email address" 
                        name="email" 
                        required 
                        autocomplete="off"
                        [(ngModel)]="email">
                </div>
                <button type="submit" class="subscribe-btn" [disabled]="isSubscribing">
                    <span *ngIf="!isSubscribing">Subscribe Now</span>
                    <span *ngIf="isSubscribing">Subscribing...</span>
                </button>
            </form>

            <div class="alert alert-success" *ngIf="subscriptionSuccess">
                <i class='bx bx-check-circle'></i> Thank you for subscribing to our newsletter!
            </div>
            <div class="alert alert-danger" *ngIf="subscriptionError">
                <i class='bx bx-error-circle'></i> {{errorMessage}}
            </div>

            <div class="privacy-notice">
                <p>We respect your privacy. Unsubscribe at any time.</p>
            </div>
        </div>
    </div>
   
</section>

<!-- End Subscribe Area -->